module.exports = __webpack_public_path__ + "static/media/bnt.5dd9ca28.svg";